import {
  CreateProactiveMsgForm,
  UpdateProactiveMsgForm,
  ProactiveMsgDto
} from "@closerplatform/spinner-openapi";
import { FieldState, FormState } from "formstate";
import {
  getLanguageOptionWithDefault,
  LanguageOption
} from "@fidget/common/components/form/languagePicker/languagePicker";
import { validateRequired } from "@fidget/common/utils/validatorsFormState";
import {
  ExistingProactiveFormFields,
  ExistingProactiveFormType,
  NewProactiveFormFields,
  NewProactiveFormType
} from "./types";

export const mapProactiveMsgToForm = (msg: ProactiveMsgDto): ExistingProactiveFormType => {
  return new FormState<ExistingProactiveFormFields>({
    id: new FieldState(msg.id),
    tag: new FormState({
      id: new FieldState(msg.tag.id),
      enabled: new FieldState(msg.tag.enabled),
      tag: new FieldState(msg.tag.tag)
    }),
    langTag: new FieldState<string>(getLanguageOptionWithDefault(msg.langTag)),
    message: new FieldState(msg.text),
    enabled: new FieldState(msg.enabled),
    displayOutsideWorkingHours: new FieldState(msg.displayOutsideWorkingHours)
  });
};

export const createNewProactiveMsgForm = (): NewProactiveFormType => {
  return new FormState<NewProactiveFormFields>({
    tagId: new FieldState(""),
    message: new FieldState("").validators(validateRequired)
  });
};

export const copyExistingProactiveMsgForm = (
  form: ExistingProactiveFormType
): ExistingProactiveFormType => {
  return new FormState<ExistingProactiveFormFields>({
    id: new FieldState(form.$.id.$),
    tag: new FormState({
      id: new FieldState(form.$.tag.$.id.$),
      enabled: new FieldState(form.$.tag.$.enabled.$),
      tag: new FieldState(form.$.tag.$.tag.$)
    }),
    langTag: new FieldState(form.$.langTag.$),
    message: new FieldState(form.$.message.$),
    enabled: new FieldState(form.$.enabled.$),
    displayOutsideWorkingHours: new FieldState(form.$.displayOutsideWorkingHours.$)
  });
};

export const mapNewFormToCreateForm = (
  form: NewProactiveFormType,
  langTag: LanguageOption
): CreateProactiveMsgForm => {
  return {
    tagId: form.$.tagId.$,
    text: form.$.message.$,
    langTag
  };
};

export const mapExistingFormToUpdateForm = (
  form: ExistingProactiveFormType
): UpdateProactiveMsgForm => {
  return {
    newTagId: form.$.tag.$.id.$,
    newLangTag: form.$.langTag.$,
    newDisplayOutsideWorkingHours: form.$.displayOutsideWorkingHours.$,
    newText: form.$.message.$,
    newEnabled: form.$.enabled.$
  };
};
